<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
    </div>
    <div class="content-body">
      <section id="vertical-tabs">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Formulario para Nueva Oferta de Trabajo</h4>
              </div>
              <div class="card-content collapse show">
                <div class="card-body">
                  <div class="card-block">
                    <aw-wizard #wizard navBarLayout="large-filled-symbols" navBarLocation="left">
                      <aw-wizard-step [navigationSymbol]="{ symbol: '1'}">
                        <!-- stepone -->
                        <form [formGroup]="stepOneForm">
                          <div class="row"><br></div>
                          <div class="row">
                            <div class='col-md-6'>
                              <div class="form-group">
                                <label class="form-control-label" for="occupation">Puesto  <span class="requiredAttribute warning">*</span></label>
                                <input class="form-control border-info" type="text" placeholder="Desarrollador Jr. Java" formControlName="occupation"
                                [ngClass]="{ 'is-invalid': f.occupation.errors && (f.occupation.dirty || f.occupation.touched) }" />
                                <small class="form-text text-muted danger" *ngIf="f.occupation.errors"
                                  class="invalid-feedback">
                                  <div
                                    *ngIf="f.occupation.errors && (f.occupation.dirty || f.occupation.touched)">
                                    Completa esta campo correctamente</div>
                                </small>
                              </div>
                            </div>
                            <div class='col-md-6'>
                              <div class="form-group">
                                <label class="form-control-label" for="experience">Área de experiencia  <span class="requiredAttribute warning">*</span></label>
                                <select class="form-control border-info input-md" formControlName="experience">
                                  <option *ngFor="let division of _listaDivisiones" [value]="division.idDivision">{{division.descripcion}}</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label class="form-control-label" for="speciality">Especialidad  <span class="requiredAttribute warning">*</span></label>
                                <select class="form-control border-info input-md" formControlName="speciality">
                                  <option *ngFor="let area of _listaAreas" [value]="area.idArea">{{area.descripcion}}</option>
                                </select>
                              </div>
                            </div>
                            <hr>
                              <div class="col-lg-12 col-xl-12">
                                <div class="card collapse-icon accordion-icon-rotate">

                                  <div class="card-header bg-blue4">
                                    <a data-toggle="collapse" class="card-title white lead"
                                      (click)="basicColorBorderCollapse1 = !basicColorBorderCollapse1"
                                      [attr.aria-expanded]="!basicColorBorderCollapse1"
                                      aria-controls="basicColorBorderCollapse1">
                                      <h4 class="text-white card-title">Habilidades socioemocionales solicitadas para el puesto</h4></a>
                                  </div>
                                  <div id="basicColorBorderCollapse1" [ngbCollapse]="basicColorBorderCollapse1">
                                    <div class="card-content">
                                      <div class="card-body border-info">
                                        <form>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="card-title">
                                                  <h6 class="text-bold-500 dark">
                                                    Las habilidades socioemocionales hacen referencia a rasgos, características y competencias personales que describen la personalidad y la forma en que interactúa una persona en un entorno social y laboral.
                                                    Son el complemento perfecto para alcanzar el puesto que deseas.</h6>   
                                                </div>
                                                <p>Busca la habilidad que deseas registrar en tu perfil y si existen resultados que coincidan, selecciónala.
                                                  Recuerda que puedes seleccionar más de una habilidad.</p>
                                                <ng-select [items]="hablidadesFiltradas" (add)="onAddHabilidad($event)" [(ngModel)]="habilidadesSeleccionadas" bindLabel="descripcion" [multiple]="true"
                                                  placeholder="Busca y selecciona las habilidades" (remove)="onRemoveHabilidad($event)" (search)="BuscarHabilidades($event.term)" maxSelectedItems="10">
                                                </ng-select>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="form-group text-center space-20">                
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>

                                  <br><br>

                                  <div class="card-header bg-blue4">
                                    <a data-toggle="collapse" class="card-title white lead"
                                      (click)="basicColorBorderCollapse2 = !basicColorBorderCollapse2"
                                      [attr.aria-expanded]="basicColorBorderCollapse2" aria-controls="basicColorBorderCollapse2">
                                      <h4 class="text-white card-title">Habilidades técnicas necesarias para el puesto</h4></a>
                                  </div>
                                  <div id="basicColorBorderCollapse2" [ngbCollapse]="!basicColorBorderCollapse2">
                                    <div class="card-content">
                                      <div class="card-body border-info">
                                        <form>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="card-title">
                                                  <h6 class="text-bold-500 dark">
                                                    Las habilidades técnicas hacen referencia a los conocimientos que debería tener una persona para realizar las actividades laborales y son adquiridas a partir de estudios.
                                                    Estas te permiten alcanzar el éxito laboral, por lo que no puedes descuidarlas.</h6>
                                                </div>
                                                <p>Busca la habilidad que deseas registrar en tu perfil y si existen resultados que coincidan, selecciónala.
                                                  Recuerda que puedes seleccionar más de una habilidad.</p>
                                                <ng-select [items]="conocimientosFiltradas" bindLabel="descripcion" [multiple]="true"
                                                  placeholder="Busca y selecciona las habilidades" (remove)="onRemoveConocimiento($event)" (add)="onAddConocimiento($event)" (search)="BuscarConocimientos($event.term)" [(ngModel)]="conocimientosSeleccionados" maxSelectedItems="10">
                                                </ng-select>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="form-group text-center space-20">
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>

                          <div class="form-group text-center">
                            <button type="button" uiSref="work" [disabled]="stepOneForm.invalid || habilidadesSeleccionadas.length<1 || conocimientosSeleccionados.length<1" class="btn btn-navy btn-raised"
                               awNextStep>
                              Siguiente paso
                              <span style="margin-left:10px;">
                                <i class="feather ft-chevron-right"></i>
                              </span>
                            </button>
                          </div>
                        </form>
                        <!-- stepone -->
                      </aw-wizard-step>
                      <aw-wizard-step [navigationSymbol]="{ symbol: '2'}">
                        <!-- steptwo -->
                        <form [formGroup]="stepTwoForm">
                          <div class="row"><br></div>
                          <div class="row">
                            <div class='col-md-6'>
                              <div class="form-group">
                                <label for="timesheetinput1">Periodo de contrato  <span class="requiredAttribute warning">*</span></label>
                                <div class="position-relative has-icon-left">
                                  <input type="text" id="timesheetinput1" class="form-control border-info" placeholder="6 meses"
                                    formControlName="period" [ngClass]="{ 'is-invalid': i.period.errors && (i.period.dirty || i.period.touched) }" />
                                  <div class="form-control-position">
                                    <i class="feather feather ft-calendar"></i>
                                  </div>
                                  <small class="form-text text-muted danger" *ngIf="i.period.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="i.period.errors && (i.period.dirty || i.period.touched)">
                                    Completa esta campo correctamente</div>
                                  </small>
                                </div>
                              </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="form-group">
                                      <label for="timesheetinput5">De :  <span class="requiredAttribute warning">*</span></label>
                                      <div class="position-relative has-icon-right">
                                        <input type="time" id="timesheetinput5" class="form-control border-info" formControlName="startTime" [ngClass]="{ 'is-invalid': i.startTime.errors && (i.startTime.dirty || i.startTime.touched) }" />
                                        <div class="form-control-position">
                                        </div>
                                        <small class="form-text text-muted danger" *ngIf="i.startTime.errors"
                                          class="invalid-feedback">
                                          <div *ngIf="i.startTime.errors && (i.startTime.dirty || i.startTime.touched)">
                                            Completa esta campo correctamente</div>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="form-group">
                                      <label for="timesheetinput6">A :  <span class="requiredAttribute warning">*</span></label>
                                      <div class="position-relative has-icon-right">
                                        <input type="time" id="timesheetinput6" class="form-control border-info" formControlName="endTime" [ngClass]="{ 'is-invalid': i.endTime.errors && (i.endTime.dirty || i.endTime.touched) }">
                                        <div class="form-control-position">
                                        </div>
                                        <small class="form-text text-muted danger" *ngIf="i.endTime.errors"
                                          class="invalid-feedback">
                                          <div *ngIf="i.endTime.errors && (i.endTime.dirty || i.endTime.touched)">
                                          Completa esta campo correctamente</div>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label for="timesheetinput1">Lugar (domicilio) :  <span class="requiredAttribute warning">*</span></label>
                                  <div class="position-relative has-icon-left">
                                    <input type="text" id="timesheetinput1" class="form-control border-info" placeholder="42 Wallaby Way, Sydney"
                                      formControlName="direction" 
                                      [ngClass]="{ 'is-invalid': i.direction.errors && (i.direction.dirty || i.direction.touched) }" />
                                    <div class="form-control-position">
                                      <i class="feather ft-map-pin"></i>
                                    </div>
                                    <small class="form-text text-muted danger" *ngIf="i.direction.errors"
                                      class="invalid-feedback">
                                      <div
                                        *ngIf="i.direction.errors && (i.direction.dirty || i.direction.touched)">
                                        Completa esta campo correctamente</div>
                                    </small>
                                  </div>
                                </div>
                            </div>
                            <div class='col-md-6'>
                              <div class="form-group">
                                <label class="form-control-label" for="modality">Modalidad :  <span class="requiredAttribute warning">*</span></label>
                                <select class="form-control border-info input-md" formControlName="modality" [ngClass]="{ 'is-invalid': i.modality.errors && (i.modality.dirty || i.modality.touched) }" >
                                  <option *ngFor="let modality of modalities" [value]="modality">{{modality}}</option>
                                </select>
                                <small class="form-text text-muted danger" *ngIf="i.modality.errors"
                                      class="invalid-feedback">
                                      <div
                                        *ngIf="i.modality.errors && (i.modality.dirty || i.modality.touched)">
                                        Completa esta campo correctamente</div>
                                    </small>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label>Sueldo entre :</label>
                                    <div class="input-group mt-0">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                      </div>
                                      <input type="text" class="form-control border-info" [maxlength]="5" inputmode="numeric" placeholder="Mínimo estimado"
                                        formControlName="minTax">
                                      <div class="input-group-append">
                                        <span class="input-group-text">.00</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label>Y :</label>
                                    <div class="input-group mt-0">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                      </div>
                                      <input type="text" class="form-control border-info" [maxlength]="5" inputmode="numeric" placeholder="Máximo estimado"
                                        formControlName="maxTax">
                                      <div class="input-group-append">
                                        <span class="input-group-text">.00</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group text-center space-20">
                            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                              awPreviousStep>
                              <span style="margin-right:10px;">
                                <i class="feather ft-chevron-left"></i>
                              </span>Paso anterior
                            </button>
                            <button uiSref="address" type="button" [disabled]="stepTwoForm.invalid || stepOneForm.invalid || habilidadesSeleccionadas.length<1 || conocimientosSeleccionados.length<1" class="btn btn-raised btn-navy"
                               awNextStep>
                              Siguiente paso
                              <span style="margin-left:10px;">
                                <i class="feather ft-chevron-right"></i>
                              </span>
                            </button>
                          </div>
                        </form>
                        <!-- steptwo -->
                      </aw-wizard-step>
                      <aw-wizard-step [navigationSymbol]="{ symbol: '3'}">
                          <!-- stepthree -->
                          <form [formGroup]="stepThreeForm">
                              <div class="row"><br></div>
                              <div class="card-body" formArrayName="repeatArray">
                                <div class="row">
                                  <div class="col-12" *ngFor="let formulario of stepThreeFormGroup?.controls; let i = index;">
                                    <div class="repeater-default">
                                      <div [formGroupName]="i" class="row">
                                        <div class="form-group mb-1 col-sm-8 col-md-10">
                                          <label for="responsability">Responsabilidad del puesto  <span class="requiredAttribute warning">*</span></label>
                                          <br>
                                          <input type="text" formControlName="responsability" class="form-control border-info" id="responsability"
                                            placeholder="Monitorización constante de los programas y aplicaciones" 
                                            [ngClass]="{ 'is-invalid': formulario?.get('responsability')?.errors && (formulario?.get('responsability').dirty || formulario?.get('responsability').touched) }" />
                                            <small class="form-text text-muted danger" *ngIf="formulario?.get('responsability').errors"
                                              class="invalid-feedback">
                                              <div
                                                *ngIf="formulario?.get('responsability')?.errors && (formulario?.get('responsability').dirty || formulario?.get('responsability').touched)">
                                                Completa esta campo correctamente</div>
                                            </small>
                                        </div>
                                        <div class="form-group col-sm-4 col-md-2 text-center mt-2">
                                          <button type="button" class="btn btn-danger" [disabled]="stepThreeFormGroup?.controls.length<=1" (click)="removeRepeat(i)"><i
                                              class="feather ft-x"></i>
                                            Quitar</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <hr>
                              </div>
    
                              <div class="form-group overflow-hidden">
                                <div class="col-12">
                                  <button data-repeater-create class="btn btn-info" 
                                  [disabled]="stepThreeFormGroup?.invalid" (click)="addRepeat()">
                                    <i class="feather ft-plus"></i> Añadir responsabilidad
                                  </button>
                                </div>
                              </div>
    
                              <div class="form-group text-center space-20">
                                <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                                  awPreviousStep>
                                  <span style="margin-right:10px;">
                                    <i class="feather ft-chevron-left"></i>
                                  </span> Anterior paso </button>
                                  <button type="button" uiSref="work" [disabled]="stepThreeForm.invalid" class="btn btn-navy btn-raised"
                                  awNextStep>
                                  Siguiente paso
                                  <span style="margin-left:10px;">
                                    <i class="feather ft-chevron-right"></i>
                                  </span>
                                </button>
                              </div>
                            </form>
                          <!-- stepthree -->
                      </aw-wizard-step>
                      <aw-wizard-step [navigationSymbol]="{ symbol: '4'}">
                        <!-- stepfour -->
                        <form [formGroup]="stepFourForm">
                          <div class="row"><br></div>
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" formControlName="negotiateCompany" [(ngModel)]="negotiateCompany">
                              A negociar con la empresa (no tengo información al respecto).
                            </label>
                          </div>
                          <hr>
                          <div class="card-body" formArrayName="repeatArrayFour">
                            <div class="row">
                              <div class="col-12" *ngFor="let formulario of stepFourFormGroup?.controls; let o = index;">
                                <div class="repeater-default">
                                  <div [formGroupName]="o" class="row">
                                    <div class="form-group mb-1 col-sm-8 col-md-10">
                                      <label for="benefit">Prestaciones del puesto</label>
                                      <br>
                                      <input type="text" formControlName="benefit" [readOnly]="negotiateCompany" class="form-control border-info" id="benefit"
                                        placeholder="Vales de depensa mensuales" 
                                        [ngClass]="{ 'is-invalid': formulario?.get('benefit')?.errors && (formulario?.get('benefit').dirty || formulario?.get('benefit').touched) }" />
                                        <small class="form-text text-muted danger" *ngIf="formulario?.get('benefit').errors"
                                          class="invalid-feedback">
                                          <div
                                            *ngIf="formulario?.get('benefit')?.errors && (formulario?.get('benefit').dirty || formulario?.get('benefit').touched)">
                                            Completa esta campo correctamente</div>
                                        </small>
                                    </div>
                                    <div class="form-group col-sm-4 col-md-2 text-center mt-2">
                                      <button type="button" class="btn btn-danger" [disabled]="stepFourFormGroup?.controls.length<=1 || negotiateCompany" (click)="removeRepeatFour(o)"><i
                                          class="feather ft-x"></i>
                                        Quitar</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr>
                          </div>

                          <div class="form-group overflow-hidden">
                            <div class="col-12">
                              <button data-repeater-create class="btn btn-info" 
                              [disabled]="stepFourFormGroup?.invalid || negotiateCompany" (click)="addRepeatFour()">
                                <i class="feather ft-plus"></i> Añadir prestación
                              </button>
                            </div>
                          </div>

                          <div class="form-group text-center space-20">
                            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                              awPreviousStep>
                              <span style="margin-right:10px;">
                                <i class="feather ft-chevron-left"></i>
                              </span> Anterior paso </button>
                              <button type="button" uiSref="work" [disabled]="stepFourForm.invalid" class="btn btn-navy btn-raised"
                              awNextStep>
                              Siguiente paso
                              <span style="margin-left:10px;">
                                <i class="feather ft-chevron-right"></i>
                              </span>
                            </button>
                          </div>
                        </form>
                        <!-- stepfour -->
                      </aw-wizard-step>
                      <aw-wizard-step [navigationSymbol]="{ symbol: '5'}">
                          <!-- stepfour -->
                          <form [formGroup]="stepFiveForm">
                            <div class="form-body">
                              <h3 class="form-section"><i class="la la-building"></i>Datos de la empresa</h3>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="company">Nombre de la empresa o institución   <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="company" formControlName="company" class="form-control border-info"
                                      placeholder="" 
                                      [ngClass]="{ 'is-invalid': a.company.errors && (a.company.dirty || a.company.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.company.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.company.errors && (a.company.dirty || a.company.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="activity"> Actividad principal de la empresa   <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="activity" formControlName="activity" class="form-control border-info" placeholder="" 
                                    [ngClass]="{ 'is-invalid': a.activity.errors && (a.activity.dirty || a.activity.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.activity.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.activity.errors && (a.activity.dirty || a.activity.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="direction2">Domicilio (empresa)   <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="direction2" formControlName="direction" class="form-control border-info" placeholder="" 
                                    [ngClass]="{ 'is-invalid': a.direction.errors && (a.direction.dirty || a.direction.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.direction.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.direction.errors && (a.direction.dirty || a.direction.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="cp">Código Postal   <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="cp" formControlName="cp" class="form-control border-info" 
                                    [ngClass]="{ 'is-invalid': a.cp.errors && (a.cp.dirty || a.cp.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.cp.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.cp.errors && (a.cp.dirty || a.cp.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="phones">Telefonos   <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="phones" formControlName="phones" class="form-control border-info" placeholder="" 
                                    [ngClass]="{ 'is-invalid': a.phones.errors && (a.phones.dirty || a.phones.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.phones.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.phones.errors && (a.phones.dirty || a.phones.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="email">Correo electrónico <span class="requiredAttribute warning">*</span></label>
                                    <input type="text" id="email" formControlName="email" class="form-control border-info" placeholder="" 
                                    [ngClass]="{ 'is-invalid': a.email.errors && (a.email.dirty || a.email.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.email.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.email.errors && (a.email.dirty || a.email.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label for="aboutCompany">Acerca de la empresa  <span class="requiredAttribute warning">*</span></label>
                                    <textarea class="form-control" formControlName="aboutCompany" [ngClass]="{ 'is-invalid': a.aboutCompany.errors && (a.aboutCompany.dirty || a.aboutCompany.touched) }" id="aboutCompany" rows="3" placeholder="Describe a la empresa"></textarea>
                                    <small class="form-text text-muted danger" *ngIf="a.aboutCompany.errors"
                                      class="invalid-feedback">
                                      <div
                                        *ngIf="a.aboutCompany.errors && (a.aboutCompany.dirty || a.aboutCompany.touched)">
                                        Completa esta campo correctamente</div>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="file">Si tienes alguna imagen relacionada a la empresa, por favor adjúntala.</label>
                                    <input type="file" class="form-control-file" (change)="onFileSelected($event)" id="file">
                                  </div>
                                </div>
                              </div>
                              <h4 class="form-section"><i class="la la-phone-square"></i>Información de contacto</h4>
                              <div class="form-group">
                                <label for="responsableEmail">Correo electrónico de responsable  <span class="requiredAttribute warning">*</span></label>
                                <input class="form-control border-info" type="text" formControlName="responsableEmail" id="responsableEmail"
                                [ngClass]="{ 'is-invalid': a.responsableEmail.errors && (a.responsableEmail.dirty || a.responsableEmail.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.responsableEmail.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.responsableEmail.errors && (a.responsableEmail.dirty || a.responsableEmail.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                              </div>
                              <div class="form-group">
                                <label for="responsableName">Nombre de responsable  <span class="requiredAttribute warning">*</span></label>
                                <input class="form-control border-info" formControlName="responsableName" type="text"  id="responsableName"
                                [ngClass]="{ 'is-invalid': a.responsableName.errors && (a.responsableName.dirty || a.responsableName.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.responsableName.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.responsableName.errors && (a.responsableName.dirty || a.responsableName.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                              </div>
                              <div class="form-group">
                                <label for="responsablePhone">Teléfono de contacto  <span class="requiredAttribute warning">*</span></label>
                                <input class="form-control border-info" formControlName="responsablePhone" id="responsablePhone" type="tel"
                                [ngClass]="{ 'is-invalid': a.responsablePhone.errors && (a.responsablePhone.dirty || a.responsablePhone.touched) }" />
                                      <small class="form-text text-muted danger" *ngIf="a.responsablePhone.errors"
                                        class="invalid-feedback">
                                        <div
                                          *ngIf="a.responsablePhone.errors && (a.responsablePhone.dirty || a.responsablePhone.touched)">
                                          Completa esta campo correctamente</div>
                                      </small>
                              </div>
                            </div>

                            <div class="form-group text-center space-20">
                              <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                                awPreviousStep>
                                <span style="margin-right:10px;">
                                  <i class="feather ft-chevron-left"></i>
                                </span> Anterior paso </button>
                                <button type="button" uiSref="work" [disabled]="stepFiveForm.invalid" class="btn btn-navy btn-raised"
                                awNextStep>
                                Siguiente paso
                                <span style="margin-left:10px;">
                                  <i class="feather ft-chevron-right"></i>
                                </span>
                              </button>
                            </div>

                          </form>
                          <!-- stepfour -->
                      </aw-wizard-step>
                      <aw-wizard-step [navigationSymbol]="{ symbol: '6'}">
                          <!-- stepfive -->
                          <!-- form externo -->
                      <section>
                          <div class="row">
                            <div class="col-12">
                              <br>
                              <div class="col">
                                <m-card [options]="options">              
                                    <ng-container mCardBody>
                                        <form class="form">
                                            <div class="form-body">
                                                <div class="col-md-12">
                                                    <div class="card overflow-hidden">
                                                      <div class="card-content">
                                                        <div class="media align-items-stretch bg-blue2 text-white rounded">
                                                          <div class="bg-blue3 p-2 media-middle">
                                                            <i class="icon-briefcase font-large-2 text-white"></i>
                                                          </div>
                                                          <div class="media-body p-2">
                                                            <h5 class="font-small-4 text-white">Fecha de publicación: {{todayDate}}</h5>
                                                            <h3 class="text-uppercase subtitle text-white">{{f.occupation.value}}</h3>
                                                            <h4 class="text-white">{{divisionSeleccionada}} | {{areaSeleccionada}}</h4>                          
                                                            <h4 class="text-white" *ngIf="i.minTax.value && i.maxTax.value">Sueldo ${{i.minTax.value}} - ${{i.maxTax.value}}</h4>
                                                            <h4 class="text-white" *ngIf="!i.minTax.value && !i.maxTax.value">Sueldo no descrito</h4>
                                                            <h4 class="text-white">{{a.company.value}} | En {{i.direction.value}}</h4>
                                                          </div>                        
                                                        </div>
                                                      </div>
                                                    </div>
                                                </div>
                                                <div class="card-body">
                                                    <h3 class="form-section"><i class="feather ft-user icon"></i> Habilidades socioemocionales solicitadas</h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <ul *ngFor="let habilidad of habilidadesSeleccionadas">
                                                            <li>{{ habilidad.descripcion }}</li>
                                                        </ul>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-award icon"></i> Habilidades técnicas necesarias</h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <ul *ngFor="let conocimiento of conocimientosSeleccionados">
                                                            <li>{{ conocimiento.descripcion }}</li>
                                                        </ul>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-paperclip icon"></i> Actividades a realizar</h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <ul  *ngFor="let formulario of stepThreeFormGroup?.controls; let i = index;">
                                                            <li>{{ formulario.get('responsability').value }}</li>
                                                        </ul>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-monitor icon"></i> Modalidad</h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <p class="font-description">{{i.modality.value}}</p>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-watch icon"></i> Horario de trabajo</h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <p class="font-description">De: {{i.startTime.value}} A: {{i.endTime.value}}</p>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-calendar icon"></i> Periodo de contrato : </h3>
                                                    <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                        <p class="font-description">{{i.period.value}}</p>
                                                    </div>
                                                    <h3 class="form-section"><i class="feather ft-clipboard icon"></i> Prestaciones y beneficios</h3>
                                                    <div *ngIf="!negotiateCompany">
                                                        <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-square">
                                                          <ul *ngFor="let formulario of stepFourFormGroup?.controls; let i = index;">
                                                            <li *ngIf="formulario.get('benefit').value!=''">{{ formulario.get('benefit').value }}</li>
                                                          </ul>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="negotiateCompany">
                                                      <div class="bs-callout-info bg-blue1 callout-border-right p-1 callout-squaree">
                                                        <ul>
                                                          <li>A tratar con la empresa</li>
                                                        </ul>
                                                      </div>
                                                  </div>
                                                </div> 
                                            </div>

                                            <div class="form-group text-center space-20">
                                              <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                                                awPreviousStep>
                                                <span style="margin-right:10px;">
                                                  <i class="feather ft-chevron-left"></i>
                                                </span> Anterior paso </button>
                                                <button type="button" uiSref="work" (click)="SuccessModel()" [disabled]="stepFourForm.invalid" class="btn btn-navy btn-raised">
                                                Subir oferta
                                                <span style="margin-left:10px;">
                                                  <i class="feather ft-chevron-right"></i>
                                                </span>
                                              </button>
                                            </div>

                                        </form>
                                    </ng-container>
                                </m-card>
                            </div>

                            </div>
                          </div>
                        </section>
                        <!-- form externo  -->
                          <!-- stepfive -->
                      </aw-wizard-step>

                    </aw-wizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
    </div>
  </div>
</div>
